<template>
  <div data-test="identity-choice-form">
    <p class="text-static-default-low body-1">
      {{ firstText }}
    </p>
    <p v-if="!isBmAgent" class="text-static-default-low body-1 mt-12">
      {{ i18n(translations.IdentityChoiceSecondText) }}
    </p>
    <p class="body-1-bold mt-12">
      {{ i18n(translations.IdentityChoiceQuestion) }}
    </p>

    <div class="mt-12">
      <RevRadio
        v-for="option in radioOptions"
        :id="option.id"
        :key="option.id"
        v-model="radioId as string"
        class="mt-16"
        :value="option.id"
        variant="full"
      >
        <template #label>{{ option.label }}</template>
      </RevRadio>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevRadio } from '@ds/components/Radio'

import type { IdDocumentsType } from '@backmarket/nuxt-layer-buyback/composables/config/useBuybackConfig'

import translations from './Identity.translations'

const props = defineProps<{
  radioOptions: {
    id: IdDocumentsType
    label: string
    isOneSide: boolean
  }[]
  isBmAgent?: boolean
}>()
const radioId = defineModel<IdDocumentsType>('id')
const i18n = useI18n()

const firstText = computed(() =>
  props.isBmAgent
    ? i18n(translations.IdentityChoiceBmAgentText)
    : i18n(translations.IdentityChoiceFirstText),
)
</script>
